export default __webpack_public_path__ + "static/developers-de51b01434d5d582c33d3d228a97f4c3.jpg";